import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import { industries } from "./industries";
import { products } from "./products";
import { appetites } from "./appetites";
import { resources } from "./resources";
import { contacts } from "./contacts";

const rootReducer = combineReducers({
    industries,
    products,
    appetites,
    resources,
    contacts,
    routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js